// extracted by mini-css-extract-plugin
export var cardContainer = "_pb-0";
export var cardHeader = "_pb-2";
export var collapsedState = "_pb-3";
export var dragHandle = "_pb-5";
export var dragHandleIcon = "_pb-6";
export var dragging = "_pb-1";
export var titleArea = "_pb-4";